import { ColumnType } from '@datachain/ui-sdk/components/dc-types';

export enum SupportedTypes {
	SIMPLE_TYPES_STRING_ITEM = 'SIMPLE_TYPES_STRING_ITEM',
	SIMPLE_TYPES_INTEGER_ITEM = 'SIMPLE_TYPES_INTEGER_ITEM',
	SIMPLE_TYPES_BIG_INTEGER_ITEM = 'SIMPLE_TYPES_BIG_INTEGER_ITEM',
	SIMPLE_TYPES_DECIMAL_ITEM = 'SIMPLE_TYPES_DECIMAL_ITEM',
	SIMPLE_TYPES_DATE_ITEM = 'SIMPLE_TYPES_DATE_ITEM',
	SIMPLE_TYPES_BOOLEAN_ITEM = 'SIMPLE_TYPES_BOOLEAN_ITEM',
	TYPES_WORDS_ITEM = 'TYPES_WORDS_ITEM',
	TYPES_FILE_ITEM = 'TYPES_FILE_ITEM',
	TYPES_BINARY_ITEM = 'TYPES_BINARY_ITEM',
	TYPES_GEOMETRY_ITEM = 'TYPES_GEOMETRY_ITEM',
}

export interface ICharacteristicType {
	id: number;
	code: SupportedTypes;
	lib: string;
	selected: boolean;
}

export const ColumnTypeMap: { [k: string]: SupportedTypes } = {
	[ColumnType.Str]: SupportedTypes.SIMPLE_TYPES_STRING_ITEM,
	[ColumnType.Int]: SupportedTypes.SIMPLE_TYPES_INTEGER_ITEM,
	[ColumnType.BigInt]: SupportedTypes.SIMPLE_TYPES_BIG_INTEGER_ITEM,
	[ColumnType.Dec]: SupportedTypes.SIMPLE_TYPES_DECIMAL_ITEM,
	[ColumnType.Date]: SupportedTypes.SIMPLE_TYPES_DATE_ITEM,
	[ColumnType.Bool]: SupportedTypes.SIMPLE_TYPES_BOOLEAN_ITEM,
	[ColumnType.Words]: SupportedTypes.TYPES_WORDS_ITEM,
	[ColumnType.File]: SupportedTypes.TYPES_FILE_ITEM,
	[ColumnType.Bin]: SupportedTypes.TYPES_BINARY_ITEM,
	[ColumnType.Geo]: SupportedTypes.TYPES_GEOMETRY_ITEM,
};
